module.exports = __webpack_public_path__ + "static/media/google.4aa053ad.png";